import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Completed = ({
  copy,
  dataLinkId,
  isActive,
  setActive,
}: {
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const iconContainerCompleted = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer} ${styles.Completed}`;

  const completedLink: string = `${styles.LinkRight} ${styles.CompletedLink} ${
    isActive ? styles.Active : ''
  }`;

  const completedIconClass = `${styles.Icon} ${styles.Completed} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faCheckSquare}
      iconClassName={completedIconClass}
      iconContainerClassName={iconContainerCompleted}
      textClassName={completedLink}
      copy={copy}
      onClick={onClick}
    />
  );
};

export default Completed;
